module.exports = __webpack_public_path__ + "img/66c2837.svg";